import { Component, Input } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-profile-sidebar',
  templateUrl: './ui-profile-sidebar.component.html',
  styleUrls: ['./ui-profile-sidebar.component.scss']
})
export class UiProfileSidebarComponent {
  @Input() infos: any;
  @Input() benefit: any;
  @Input() vinculo: any;
  @Input() isColaboratorModule: boolean;
  @Input() newBrand: boolean;
}
